import { ReactImageGalleryItem } from 'react-image-gallery';
import { PropertyImage } from '../../../../../services/dtos/property';
import toSrcSetData from '../progressive-image/toSrcSetData';

export default function toGalleryImages(images: PropertyImage[] = [], defaultDescription?: string): ReactImageGalleryItem[] {
  return images.map((image) => {
    const { large, about } = image;
    const { srcSet } = toSrcSetData(image);

    return {
      original: large,
      description: about || defaultDescription,
      srcSet,
    };
  });
}
